module.exports = __webpack_public_path__ + "img/kalastuspaikka_original.69677765.jpg";